import { generateRandomId, openLink } from '@/utils'

interface KemCardTerm {
  id: string
  label: string
  link1?: string
  onPressLink1?: () => void
  afterLink1?: string
  link2?: string
  onPressLink2?: () => void
  afterLink2?: string
  link3?: string
  onPressLink3?: () => void
}

// Links for Kem card terms and conditions
const links = {
  eSignNotice: 'https://kem.app/e-sign-notice',
  privacyPolicy: 'https://kem.app/privacy-policy',
  interlaceTerms: 'https://kem.app/terms-and-conditions',
}

export const kemCardTermsChecklist: KemCardTerm[] = [
  {
    id: generateRandomId(),
    label: 'I accept the ',
    link1: 'E-Sign Notice',
    onPressLink1: () => openLink(links.eSignNotice),
    afterLink1: ', the ',
    link2: 'Privacy Policy',
    onPressLink2: () => openLink(links.privacyPolicy),
    afterLink2: ' and ',
    link3: 'Terms and Conditions',
    onPressLink3: () => openLink(links.interlaceTerms),
  },
  {
    id: generateRandomId(),
    label:
      'I certify that I am the person whose identity is being verified and that the information provided is accurate.',
  },
  {
    id: generateRandomId(),
    label:
      'I acknowledge that the Kem Card is issued by a third-party provider and that Kem is not responsible for card-related issues.',
  },
]
